import axios, { type AxiosInstance } from "axios"
import config from "config"
import type { ICreateLesson, ILesson, IUpdateLesson } from "types/lessonTypes"

import authService from "./authService"

class LessonService {
  private http: AxiosInstance

  public constructor() {
    this.http = axios.create({
      baseURL: config.apiUrl,
      headers: {
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    })
  }

  public createLesson = async (createLesson: ICreateLesson): Promise<ILesson> => {
    const accessToken = await authService.getAccessToken()

    var bodyFormData = new FormData()
    bodyFormData.append("type", createLesson.type)
    bodyFormData.append("name", createLesson.name)
    bodyFormData.append("description", createLesson.description)
    bodyFormData.append("chapterId", createLesson.chapterId)
    bodyFormData.append("imageFile", createLesson.imageFile)
    bodyFormData.append("id", createLesson.id)

    const { data } = await axios({
      method: "post",
      baseURL: config.apiUrl,
      url: "/lesson",
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${accessToken}`,
      },
    })

    return data
  }

  public getLessons = async (): Promise<Array<ILesson>> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.get<Array<ILesson>>("/lesson", config)

    return data
  }

  public getLesson = async (id: string): Promise<ILesson> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.get<ILesson>(`/lesson/${id}`, config)

    return data
  }

  public getChapterLessons = async (chapterId: string): Promise<Array<ILesson>> => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const { data } = await this.http.get<Array<ILesson>>(`/chapter/${chapterId}/lesson`, config)

    return data
  }

  public updateLesson = async (lessonId: string, updateLesson: IUpdateLesson): Promise<ILesson> => {
    const accessToken = await authService.getAccessToken()

    var bodyFormData = new FormData()
    bodyFormData.append("type", updateLesson.type)
    bodyFormData.append("name", updateLesson.name)
    bodyFormData.append("description", updateLesson.description)
    bodyFormData.append("chapterId", updateLesson.chapterId)

    if (updateLesson.imageFile !== undefined) {
      bodyFormData.append("imageFile", updateLesson.imageFile)
    }

    const { data } = await axios({
      method: "put",
      baseURL: config.apiUrl,
      url: `/lesson/${lessonId}`,
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${accessToken}`,
      },
    })

    return data
  }

  public deleteLesson = async (lessonId: string) => {
    const accessToken = await authService.getAccessToken()

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    const resp = await this.http.delete(`/lesson/${lessonId}`, config)

    return resp
  }
}

const lessonService = new LessonService()

export default lessonService
